import Flickity from 'flickity';
import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class AnniversaryController{

  constructor(options) {
    this.options = options;
    console.log('ANNIVERSARY CONTROLLER');

    this.transitionIn();
    this.updateUI();

    // track the scroll position
    $(window).scroll( e => this.handleScroll(e) );

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

  }

  transitionIn() {

    // reveal the home hero text
    $('.anniversary__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.anniversary__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

  updateUI() {
    const st = $(window).scrollTop();
    const trig1 = $(window).height() * 0.75;
    const trig2 = $(window).height() * 0.35;
    // const trig3 = $(window).height() * 0.15;

  }

  handleScroll() {
    this.updateUI();
  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/AnniversaryController.js